import { render, staticRenderFns } from "./FormElement.vue?vue&type=template&id=7867184d"
import script from "./FormElement.vue?vue&type=script&lang=js"
export * from "./FormElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports